import React from "react";

const Title = () => {
  return <div style={{fontSize:"75px"}}>Cistercian Symbols</div>;
};

export default Title;
